<template>
	<div>
		<!--头-开始-->
		<!-- 	<header class="header hdFF Huans flexC">
			<a href="javascript:history.back();" class="hdFF_left">
				<span class="iconfontll icon-zuojiantou"></span>
			</a>
			<div class="hdFFCon">
				<span class="hdname">{{$t('message.activitycenter')}}</span> -->
		<!-- <span class="hdFFicon iconfontll icon-yanzhengma1"></span> -->
		<!-- </div>
			<div class="headfrbox flexC">
				<router-link :to="{name: 'kefu'}" class="headfritem flexC">
					<img src="@/assets/wap/images/icon/kficon.png" />
					<span>{{$t('message.kefu')}}</span>
				</router-link>
			</div>
		</header> -->
		<Header Title="activitycenter" :isIcon="false"></Header>
		<!--头-结束-->
		<article class="Huans IndCon">
			<!-- 	<van-tabs title-active-color="#284EF1" title-inactive-color="var(--font-color)" color="#284EF1"
				v-model="Tabactive" @change="onchange" swipeable sticky offset-top="46px" >
				<van-tab v-for="(item, index) in tabList" :key="index" :title="item.title"> -->
			<div class="IndBox">
				<div class="swiper" id="thumbs2">
					<div class="swiper-wrapper">
						<!-- sticky offset-top="90px" -->
						<van-tabs background="var(--bg-color)" title-active-color="#fff" title-inactive-color="#303EF6"
							color="#4C505B" v-model="cateidx" @change="oncatechange" swipeable sticky offset-top="46px"
							swipe-threshold="0">
							<van-tab v-for="(itm, idx) in catelist" :key="idx">
								<div :class="{'swiper-slide-thumb-active' : cateidx==idx }" slot="title">
									<div class="Huans IndTita flexC fl-cen">
										<p>{{itm.title}}</p>
									</div>
								</div>
								<!-- 内容 -->
								<div v-if="Tabactive==0" class="swiper-slide">
									<van-list v-model="loading" :finished="finished"
										:finished-text="$t('message.nomore')" @load="getList">
										<div class="divul">
											<div v-for="(item, index) in list" :key="index" @click="goDetail(item)"
												class="divli">
												<div class="divliTimg">

													<!-- <img class="Timg" :src="item.thumb" /> -->
													<van-image class="Timg" fit="contain" :src="item.thumb" />
													<div class="LTtag">{{item.status}}</div>
												</div>
												<div class="divlicont flexC fl-bet">
													<div class="divlititle van-ellipsis">{{item.title}}</div>
													<!-- <div class="divlitime">{{$t('message.actTime')}}：{{item.show_time}}</div> -->
													<div class="divlitime">{{$t('message.Detail')}}</div>
												</div>
											</div>
										</div>
									</van-list>
									<!-- <div class="nodata">
												<img class="no_img" src="@/assets/wap/images/icon/nodata.png" />
												<p class="no_text">{{$t('message.nodata')}}~</p>
											</div> -->
								</div>
								<div v-if="Tabactive==1" class="swiper-slide">
									<van-list v-model="loading1" :finished="finished1"
										:finished-text="$t('message.nomore')" @load="getList1">
										<div class="divaplyul">
											<!-- 每项 -->
											<div v-for="(item, index) in list1" :key="index" @click="goDetail(item)"
												class="diaplyli">
												<div class="diaplylibox flexC">
													<!-- 	<div class="TRtag">{{item.status}}</div> -->
													<div class="diaplyimg">
														<img class="aplyimg" :src="item.thumb">
													</div>
													<div class="dplycont ">
														<!-- van-ellipsis -->
														<div class="dplytitle  van-multi-ellipsis--l2">
															{{item.title}}
														</div>
														<!-- <div class="dplytime">
																	{{$t('message.actTime')}}：{{item.show_time}}
																</div> -->
														<div class="dplybtm flexC fl-bet">
															<div class="dplybtmfl flexC">
																<!-- 	<div class="dplystxt">{{$t('message.state')}}：</div> -->
																<!-- <div class="dplybtn bg_v">申请通过</div> -->
																<!-- <div class="dplybtn bg_h">可领取</div> -->
															</div>
															<div v-if="!isapply" @click.stop="onshowApply(item,index)"
																class="applybtn">申请</div>
															<div v-if="isapply" @click.stop="onshowApply(item,index)"
																class="applybtn sqbtn">收起</div>
														</div>
													</div>
												</div>
												<div v-show="isapply" class="sqmainbox">
													<ul>
														<li class="flexC">
															<div class="sq_fl flexC">
																<div class="sq_lable">当前等级：</div>
																<div class="sq_text">VIP 10</div>
															</div>
															<div class="sq_fr"></div>
														</li>
														<li class="flexC">
															<div class="sq_fl flexC">
																<div class="sq_lable">生日日期：</div>
																<div class="sq_text">1982-08-12</div>
															</div>
															<div class="sq_fr">距<span
																	class="daynum color_v fw">98</span>天可领取
															</div>
														</li>
														<li class="flexC">
															<div class="sq_fl flexC">
																<div class="sq_lable">可领金额：</div>
																<div class="sq_text color_h  fw">680</div>
															</div>
															<div class="sq_fr">
																<div class="lqbtn">领取</div>
															</div>
														</li>
														<li class="flexC">
															<div class="sq_fl flexC">
																<div class="sq_lable">流水倍数：</div>
																<div class="sq_text">10倍</div>
															</div>
															<div class="sq_fr"></div>
														</li>
														<li class="flexC">
															<div class="sq_fl flexC">
																<div class="sq_lable">计算公式：</div>
																<div class="sq_text">680x10倍流水=6800可提现</div>
															</div>
															<div class="sq_fr"></div>
														</li>
														<li class="flexC">
															<div class="sq_fl flexC">
																<div class="sq_lable">可玩游戏：</div>
																<div class="sq_text">电子</div>
															</div>
															<div class="sq_fr"></div>
														</li>
														<li class="flexC">
															<div class="sq_fl flexC">
																<div class="sq_lable">最高上限：</div>
																<div class="sq_text">无上限</div>
															</div>
															<div class="sq_fr"></div>
														</li>
													</ul>
													<!-- 说明 -->
													<div class="tipsbox">
														<div class="tipstitle color_3">说明：</div>
														<div class="tipstxt color_3">
															1.必须完善个人信息，且单笔大于100充值记录，方可自助领取。
														</div>
														<div class="tipstxt color_3">2.任何欺骗，套利行为，我方有权收回，并持有封号权利。
														</div>
														<div class="tipstxt color_3">3.此优惠生日当天可以领取，过期不候。</div>
													</div>

												</div>
											</div>
											<!-- 每项end -->

										</div>
									</van-list>
								</div>
								<!-- 内容结束 -->
							</van-tab>
						</van-tabs>
					</div>
				</div>
			</div>

			<!-- </van-tab>
			</van-tabs> -->

		</article>
	</div>
</template>

<script>
	import {
		discountGettopcat,
		discountGetlist,
		discountInfo,
		applyDiscount
	} from "@/api/urls";
	import Header from '@/components/wap/public/header.vue';
	export default {
		name: 'activity',
		components: {
			Header,
		},
		data() {
			return {
				tabList: [{
					title: "优惠活动"
				}, {
					title: "活动申请"
				}],
				Tabactive: 0,
				catelist: [{
						title: "全部",
					}
					// ,{
					// 	title: "真人",
					// },{
					// 	title: "棋牌",
					// },{
					// 	title: "电子",
					// }, {
					// 	title: "捕鱼",
					// }, {
					// 	title: "彩票",
					// }, {
					// 	title: "其它",
					// },
				],
				cateidx: 0,
				cid: 0,
				currPage: 1,
				pageSize: 10,
				list: [],
				loading: false,
				finished: false,
				currPage1: 1,
				pageSize1: 10,
				list1: [],
				loading1: false,
				finished1: false,
				isapply: false, //是否显示申请内容
				id: 0,
				detail: {}
			}
		},
		created() {
			this.getCategory()
			// this.getList();
		},
		mounted() {
			this.getCategory()
		},
		methods: {

			onchange(index) {
				// console.log(index, "index")
				this.Tabactive = index;
				// this.Tabid = this.tabList[index].id;
				if (this.Tabactive == 0) {
					this.list = [];
					this.currPage = 1;
					this.getList();
				} else if (this.Tabactive == 1) {
					this.list1 = [];
					this.currPage1 = 1;
					this.getList1();
				}
			},
			oncatechange(index) {
				console.log(index, "index")
				this.cateidx = index;
				this.cid = this.catelist[index].id;
				if (this.Tabactive == 0) {
					this.list = [];
					this.currPage = 1;
					this.getList();
				} else if (this.Tabactive == 1) {
					this.list1 = [];
					this.currPage1 = 1;
					this.getList1();
				}

			},
			//优惠分类列表
			getCategory() {
				var params = {
					'lang': this.$store.state.lang,
				}
				discountGettopcat(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						// this.cid = data[0].id;
						var objdata = {
							create_time: null,
							id: 0,
							lang: null,
							lang_text: "",
							sort: 0,
							thumb: "0",
							title: "全部",
						};
						data.unshift(objdata)
						this.catelist = data;
						// if (this.Tabactive == 0) {
						// 	this.list = [];
						// 	this.currPage = 1;
						// 	this.getList();
						// } else if (this.Tabactive == 1) {
						// 	this.list1 = [];
						// 	this.currPage1 = 1;
						// 	this.getList1();
						// }

					}
				})
			},
			getList() {
				// if(this.cid==0){
				// 	return false
				// }
				var params = {
					"page": this.currPage,
					"cid": this.cid,
						'lang': this.$store.state.lang,
				};
				this.loading = true;
				this.finished = false;
				discountGetlist(params).then(({
					code,
					data,
					pages,
					msg
				}) => {
					if (code === 200) {
						const _list = data;
						this.list = [...this.list, ..._list];

						if (this.currPage < pages) {
							this.currPage = this.currPage + 1;
							// 加载状态结束
							this.loading = false;
						} else {
							this.finished = true;
						}
					} else {
						this.finished = true;
						this.$toast(msg);
					}
				})
			},
			getList1() {
				// if(this.cid==0){
				// 	return false
				// }
				var params = {
					"page": this.currPage1,
					"cid": this.cid,
						'lang': this.$store.state.lang,
				};
				this.loading1 = true;
				this.finished1 = false;
				discountGetlist(params).then(({
					code,
					data,
					pages,
					msg
				}) => {
					if (code === 200) {
						const _list = data;
						this.list1 = [...this.list1, ..._list];

						if (this.currPage1 < pages) {
							this.currPage1 = this.currPage1 + 1;
							// 加载状态结束
							this.loading1 = false;
						} else {
							this.finished1 = true;
						}
					} else {
						this.finished1 = true;
						this.$toast(msg);
					}
				})
			},
			// 获取优惠详情
			getDetail() {
				var params = {
					'id': this.id,
						'lang': this.$store.state.lang,
				};
				discountInfo(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.detail = data;
					}
				})
			},
			// 进入详情
			goDetail(item) {
				// is_page0是APP页面打开，1是外链打开
				// is_open1跳转到链接打开，0则是显示内容
				if (item.is_page == 0) {
					this.$router.push({
						path: '/actDetail',
						query: {
							id: item.id
						}
					})
				} else {
					var url = item.murl;
					if (item.is_open == 1) {
						if (url != '') {
							var temp = url.split('?'); //对url地址进行分割
							var pram1 = temp[0];
							var pram2 = temp[1];

							var pathurl = pram1.split('/'); //对url地址进行分割
							var path0 = pathurl[0];
							var path1 = pathurl[1];
							if (pram2 != undefined) {
								var keyValue = pram2.split("&");
								var objData = {};
								for (var i = 0; i < keyValue.length; i++) { //循环分割挂过后的地址
									var item = keyValue[i].split("=");
									var key = item[0];
									var value = item[1];
									objData[key] = value;
								}
							}
							// console.log(url, "url", temp, "temp");
							// console.log(pram1, "pram1", pram2, "pram2");
							// console.log(pathurl, "pathurl", path0, "path0", path1, "path1");
							// console.log(keyValue,"keyValue",objData,'objData') //objData就是我么分割后从上个页面传过来数据的对象
							if (path0 == '' && pram2 != undefined) {
								// 页面链接
								this.$router.push({
									path: pram1,
									query: objData
								})

							} else {
								this.$router.push({
									path: '/link',
									query: {
										url: url
									}
								})
							}

						}
					}
				}
			},
			// 申请按钮操作
			onshowApply(item, index) {
				// is_open1跳转到链接打开，0则是显示内容
				// this.isapply = !this.isapply;
				// if (item.is_open == 0) {
				// this.isapply = !this.isapply;
				// if(this.isapply){
				this.$dialog.confirm({
						title: '提示',
						message: '确定申请优惠活动吗？',
					})
					.then(() => {
						// on confirm
						this.submitApply(item.id)
					})
					.catch(() => {
						// on cancel
					});

				// }
				// } else {
				// 	this.$router.push({
				// 		path: '/link',
				// 		query: {
				// 			url: item.murl
				// 		}
				// 	})
				// }
			},
			// 申请优惠活动
			submitApply(id) {
				if (this.$store.state.token == '') {
					this.$toast(this.$t('message.plogin'));
					return false;
				}
				var params = {
					'id': id, //优惠活动ID
					// 'form':id,//提交内容数组,暂不传
					// 'cate_id':id,//可不填写，分类ID,暂不传
				};
				applyDiscount(params).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						this.$toast(msg);
					} else {
						this.$toast(msg);
					}
				})
			},

		},
		// beforeCreate() {
		// 	document.querySelector('body').setAttribute('style', 'background:rgb(237, 241, 255)')
		// },
		// beforeDestroy() {
		// 	document.querySelector('body').removeAttribute('style')
		// }
	}
</script>

<style lang="less" scoped>
	.IndCon {
		padding-top: 46px;
	}

	.header {
		height: 46px;
	}

	/deep/ .van-tabs__nav {
		background-color: var(--bg-color);
	}

	.swiper-wrapper /deep/.van-tabs--line .van-tabs__wrap {
		height: auto;
	}

	.swiper-wrapper .IndTita {
		height: auto;
		padding: 4px 15px;
		border-radius: 100px;
		border: 0px solid #d9e3ee;
	}

	.swiper-wrapper /deep/.van-tabs__nav--line.van-tabs__nav--complete {
		padding: 15px;
		border-top: 1px solid var(--border-color) !important;
	}

	.swiper-wrapper /deep/.van-tabs__wrap--scrollable .van-tab {
		padding-right: 10px;
		padding-left: 0;
	}

	.swiper-wrapper /deep/.van-tabs__line {
		display: none;
	}

	#thumbs2 /deep/ .van-tabs__nav {
		justify-content: flex-start;
	}

	#thumbs2 /deep/ .van-tab {
		flex: none;
	}

	#thumbs2 .swiper-slide-thumb-active>div {
		// background: #017efe;
		// border: 1px solid #017efe;
		// color: #FFF;
		background: var(--tabson-bgcolor);
		// border: 1px solid var(--tabson-bdcolor);
		color: var(--tabson-color);
	}

	.swiper-slide {
		// padding-top: 60px;
		flex-shrink: 0;
		width: 100%;
		height: 100%;
		position: relative;
		transition-property: transform;
	}

	// 列表
	.divul {
		padding: 10px;
		font-size: 0.1rem;

		.divli {
			margin-bottom: 10px;
			position: relative;
			padding: 10px;
			background-color: var(--bg-color);
			border-radius: 10px;

			.divliTimg {
				width: 100%;
				position: relative;
				border-radius:5px;
				overflow: hidden;

				.Timg {
					// 385x180
					width: 100%;
					min-height:160px;
					border-radius: 5px;
					overflow: hidden;
				}

				.LTtag {
					padding: 4px 15px;
				}
			}

			.divlicont {
				margin: 10px 0 5px;

				.divlititle {
					flex: 1;
					color: var(--font-color);
					font-size: 0.11rem;
					text-align: left;
				}

				.divlitime {
					max-width: 45%;
					margin-left: 10px;
					padding: 4px 10px;
					color:var(--navbtn-color);
					font-size: 0.09rem;
					border-radius: 5px;
					text-align: left;
					background-color:var(--navbtn-bgcolor);
				}
			}
		}
	}

	// 活动申请
	.divaplyul {
		padding: 10px;

		.diaplyli {
			padding: 10px;
			background-color: var(--bg-color);
			border-radius: 10px;
			text-align: left;
			margin-bottom: 10px;

			.diaplylibox {
				justify-content: flex-start;
				position: relative;
			}

			.TRtag {
				position: absolute;
				top: 0;
				right: 0;
				padding: 4px 10px;
				background-image: linear-gradient(to right, #F73801, #F48C0F, #FECB20);
				font-size: 0.09rem;
				color: #fff;
				text-align: center;
				border-radius: 5px;
				-webkit-box-shadow: 0 0.02rem 0.1rem rgb(0 0 0 / 42%);
				box-shadow: 0 0.02rem 0.1rem rgb(0 0 0 / 42%);
			}

			.diaplyimg {
				width: 100px;
				position: relative;
				border-radius: 5px;
				overflow: hidden;

				.aplyimg {
					width: 100%;
				}


			}

			.dplycont {
				flex: 1;
				margin: 0 0 0 10px;

				.dplytitle {
					width: 200px;
					color: var(--font-color);
					font-size: 0.12rem;
					text-align: left;
				}

				.dplytime {
					padding: 5px 0 10px;
					color: var(--font-color);
					font-size: 0.09rem;
				}

				.dplybtm {
					color: var(--font-color);
					font-size: 0.09rem;

					.dplybtmfl {
						flex: 1;
					}

					.dplystxt {
						font-size: 0.12rem;
					}

					.dplybtn {
						padding: 4px 15px;
						color: #fff;
						font-size: 0.09rem;
						border-radius: 5px;
					}

					.applybtn {
						padding: 4px 15px;
						color: #363EEB;
						font-size: 0.1rem;
						border-radius: 5px;
						border: 1px solid #363EEB;
					}

					.sqbtn {
						color: var(--text-color);
						border: 1px solid var(--text-color);
					}
				}
			}
		}
	}

	.sqmainbox {
		ul {
			margin-top: 10px;
			border-top: 1px solid var(--border-color);

			li {
				padding: 0.09rem 0;
				font-size: 0.11rem;
				border-bottom: 1px solid var(--border-color);

				.sq_fl {
					flex: 1;

					.sq_lable {}

					.sq_text {
						font-size: 0.11rem;
						color: var(--font-color);
					}
				}

				.sq_fr {
					.daynum {
						margin: 0 5px;
					}

					.lqbtn {
						padding: 4px 15px;
						color: #fff;
						font-size: 0.1rem;
						border-radius: 5px;
						// border: 1px solid #363EEB;
						background-color: #363EEB;
					}
				}
			}
		}
	}

	.tipsbox {
		padding: 15px 0;
		text-align: left;
		font-size: 0.11rem;
	}

	.tipstitle {
		padding: 0 0 10px;
	}

	.tipstxt {
		padding: 5px 0;
	}

	.bg_v {
		background-color: #3DE82A !important;
	}

	.bg_h {
		background-color: #FAA552 !important;
	}

	.color_v {
		color: #3DE82A !important;
	}

	.color_h {
		color: #E60E00 !important;
	}

	.fw {
		font-weight: bold;
	}
</style>


// WEBPACK FOOTER //
// src/components/wap/activity.vue